// Color de identidad del módulo Caja Proyectos — mismo patrón que las otras Cajas.
export const CAJA_PROYECTOS_COLOR = "#6a1b9a";
